module.exports = __webpack_public_path__ + "static/img/7_IMG_20160307_164959.01cba1d8.jpg";